<template>
  <div class="py-8 px-6 text-center text-sm">
    <div class="flex flex-row justify-center items-center gap-2">
      <div
        class="i-heroicons-outline-search-circle !h-6 !w-6 !text-gray-600"
      ></div>
      <p class="font-semibold text-gray-600 text-lg mt-0.5">Searching...</p>
    </div>
    <p class="mt-2 text-gray-500">Please wait while we search for results</p>
  </div>
</template>
